import styled from 'styled-components';

import { Icon } from 'components/Icon';

const Trigger = styled(Icon)`
  svg {
    width: 3.6rem;
    height: 3.6rem;
  }
`;

export { Trigger };
